// extracted by mini-css-extract-plugin
export default {"imageWrapper":"lF-z","hovered":"mF-z","hoverImage":"nF-z","mainImage":"oF-z","imageNoBackground":"pF-z","fullSizeImage":"qF-z"};